export default __webpack_public_path__ + "static/media/defaultHome.8b0ca96c.svg";